import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import { slimSelectSettings } from "../helpers/slim_select_helpers"

export default class extends Controller {
  static values = {
    searchPlaceholder: { type: String, default: "" },
    placeholderText: { type: String, default: "" },
  }

  connect() {
    const data = Array.from(this.element.options).map((opt) => ({
      value: opt.value,
      text: opt.text,
      html: this.optionHtml(opt.dataset.color, opt.text),
      selected: opt.selected,
    }))

    // The same controller drives the single primary-type field and the multi-select for the
    // additional types; only the deselect/close behaviour differs between the two.
    const multiple = this.element.multiple

    this.slimselect = new SlimSelect({
      select: this.element,
      data,
      settings: slimSelectSettings({
        searchPlaceholder: this.searchPlaceholderValue,
        placeholderText: this.placeholderTextValue,
        allowDeselect: multiple,
        closeOnSelect: !multiple,
      }),
      events: {
        searchFilter: (option, search) => {
          if (search.length === 0) return true
          const terms = search.toLowerCase().split(" ")
          const text = option.text.toLowerCase()
          return terms.every((t) => text.includes(t))
        },
      },
    })
  }

  disconnect() {
    this.slimselect?.destroy()
  }

  optionHtml(color, label) {
    const safeColor = this.sanitizeColor(color)
    const escaped = this.escapeHtml(label)
    return `<span class="inline-flex items-center gap-2"><span style="background-color:${safeColor};" class="inline-block w-3 h-3 rounded-full border border-gray-300"></span><span>${escaped}</span></span>`
  }

  sanitizeColor(color) {
    if (!color) return "#009C72"
    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : "#009C72"
  }

  escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
